import { createAction } from '@reduxjs/toolkit';

import type { RouteMBCBulkEntry } from '@modules/meritBadgeCounselors/routes.types';

import { mbcBulkEntryModule } from '../constants';

export const routeMBCBulkEntry = createAction(
  `${mbcBulkEntryModule}/ROUTE_MBC_BULK_ENTRY`,
);

export const goToMBCBulkEntryRoute = createAction<RouteMBCBulkEntry>(
  routeMBCBulkEntry.type,
);

export const ROUTE_MBC_BULK_ENTRY = routeMBCBulkEntry.type;
